export default __webpack_public_path__ + "static/media/stick.d546c597.svg";